import React from "react";
import { monthConverter } from "utils/common";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  let levelName = "";
  if (currentLevel === "nasional") {
    levelName = "Nasional";
  } else if (currentLevel === "induk") {
    levelName = "BKK Induk";
  } else if (currentLevel === "wilker") {
    levelName = "BKK Wilker";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  // Helper to render table rows
  const renderRows = () => {
    if (reportsData.length === 0) {
      return (
        <tr>
          <td colSpan={7}>Tidak Ada Data</td>
        </tr>
      );
    }

    return reportsData.map((item, index) => (
      <tr key={index}>
        <td style={{ width: "80px" }}>{index + 1}</td>
        <td>
          {item?.bkk_name || item?.name || item?.bkk_id?.split("|")[1] || "-"}
        </td>
        <td>
          {item?.province_name || item?.province_id?.split("|")[1] || "-"}
        </td>
        <td>
          {item?.district_name || item?.district_id?.split("|")[1] || "-"}
        </td>
        <td>{item?.operator_name || "-"}</td>
        <td>{item?.phone_number || "-"}</td>
        <td>{item?.email || "-"}</td>
      </tr>
    ));
  };

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, DATA DASAR BKK WILKER</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {reportInfo?.statusPeriode === "monthly" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        {currentLevel === "induk" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              BKK Induk
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.induk?.split("|")[1] || "-"}
            </th>
          </tr>
        )}
        {currentLevel === "wilker" && (
          <>
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                BKK Induk
              </th>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                : {reportInfo?.induk?.split("|")[1] || "-"}
              </th>
            </tr>
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                BKK Wilker
              </th>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                : {reportInfo?.wilker?.split("|")[1] || "-"}
              </th>
            </tr>
          </>
        )}
      </table>
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: "center", width: "80px" }}>No</th>
            <th>
              {currentLevel === "nasional"
                ? "BKK Induk"
                : currentLevel === "induk"
                ? "BKK Wilker"
                : "Nama BKK"}
            </th>
            <th>Provinsi</th>
            <th>Kab/Kota</th>
            <th>Nama Petugas</th>
            <th>No Telepon</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>{renderRows()}</tbody>
      </table>
    </div>
  );
};

export default TableComponent;
